import { render, staticRenderFns } from "./SchemeInfo.vue?vue&type=template&id=1dccdb53&scoped=true&"
import script from "./SchemeInfo.vue?vue&type=script&lang=js&"
export * from "./SchemeInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchemeInfo.vue?vue&type=style&index=0&id=1dccdb53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dccdb53",
  null
  
)

export default component.exports